import firebase from "firebase";
import { config } from "../config";

firebase.initializeApp(config.firebase.auth);

export default firebase;
